<script>
import Container from "@/components/partials/Container.vue";
import TitleComponent from "@/components/TitleComponent.vue";
import PrimaryButton from "@/components/buttons/PrimaryButton.vue";

export default {
  name: "ContactForm",
  components: {PrimaryButton, TitleComponent, Container},
}
</script>

<template>
    <container class="mt-24">
      <div class="w-full flex flex-col">
        <title-component title="Ainda possui dúvidas?"
                         sub-title="Entre em contato agora mesmo e tire todas as suas dúvidas"
        />
        <div class="w-full flex justify-center">
          <primary-button title="Tire suas dúvidas via WhatsApp"/>
        </div>
      </div>
    </container>
</template>